export default __webpack_public_path__ + "static/media/57.4b074ec7.jpg";